import React from "react";

function hexToR(h) {
  return parseInt(cutHex(h).substring(0, 2), 16);
}

function hexToG(h) {
  return parseInt(cutHex(h).substring(2, 4), 16);
}

function hexToB(h) {
  return parseInt(cutHex(h).substring(4, 6), 16);
}

function cutHex(h) {
  return h.charAt(0) == "#" ? h.substring(1, 7) : h;
}

const hexToRgb = hex => {
  const r = hexToR(hex);
  const g = hexToG(hex);
  const b = hexToB(hex);

  return `${r}, ${g}, ${b}`;
};

const LoadingIcon = ({ size = 48, color }) => {
  const hex = color || "#E8262D";
  const borderColor = `rgba(${hexToRgb(hex)}, 0.2)`;
  return (
    <div
      className="circle"
      style={{ borderColor, borderTopColor: color, width: size, height: size }}
    ></div>
  );
};

export default LoadingIcon;
